<template>
  <span class="user-info-popup-control">
    <slot name="trigger" :open="open">
      <button type="button" class="default-trigger" @click="open">
        <van-icon name="manager" size="24" />
      </button>
    </slot>

    <van-popup
      v-model="visible"
      get-container="body"
      round
      position="center"
      :z-index="5000"
      :style="{ width: '80%', padding: '20px', borderRadius: '12px' }"
    >
      <div class="user-info-card">
        <div class="info-header">
          <div class="avatar-large">
            <van-icon name="manager" size="40" color="#fff" />
          </div>
          <div class="info-title">{{ $t('user_info_title') }}</div>
        </div>
        <div class="info-content">
          <div class="info-item">
            <span class="label">{{ $t('user_info_name') }}</span>
            <span class="value">{{ userName || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('user_info_id') }}</span>
            <span class="value">{{ userId || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('user_info_current_role') }}</span>
            <span class="value">{{ currentRoleText }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('user_info_language') }}</span>
            <div class="language-switch">
              <span :class="['lang-option', { active: currentLanguage === 'ZH' }]" @click="switchLanguage('ZH')">{{ $t('language_zh') }}</span>
              <span class="divider">|</span>
              <span :class="['lang-option', { active: currentLanguage === 'EN' }]" @click="switchLanguage('EN')">English</span>
            </div>
          </div>
        </div>
        <div class="info-footer">
          <van-button type="info" block round color="#00b852" @click="visible = false">
            {{ $t('close') }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </span>
</template>

<script>
import {Button, Icon, Popup, Toast} from 'vant';
import {getLocalStorage, setLocalStorage} from '@/utils/index';

function normalizeLanguage(value) {
  return String(value || '').toUpperCase().startsWith('ZH') ? 'ZH' : 'EN';
}

export default {
  name: 'UserInfoPopup',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
  },
  props: {
    userId: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    currentRole: {
      type: String,
      default: '',
    },
    roleId: {
      type: [String, Number],
      default: '',
    },
    territoryType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      currentLanguage: normalizeLanguage(getLocalStorage('language') || 'EN'),
    };
  },
  computed: {
    currentRoleText() {
      const role = this.currentRole || '';
      const territoryType = this.territoryType || '';
      if (String(this.roleId) === '2' && role && territoryType) return `${role} | ${territoryType}`;
      return role || '--';
    },
  },
  methods: {
    open() {
      this.visible = true;
    },
    switchLanguage(lang) {
      if (this.currentLanguage === lang) return;
      this.currentLanguage = lang;
      this.$i18n.locale = lang;
      setLocalStorage('language', lang);
      Toast.success(lang === 'ZH' ? this.$t('language_switched_zh') : this.$t('language_switched_en'));
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info-popup-control {
  display: contents;
}

.default-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(135deg, #00b852 0%, #006b4f 100%);
  border: 1px solid rgba(255, 255, 255, 0.36);
  box-shadow: 0 8px 18px rgba(0, 24, 14, 0.22);
}

.user-info-card {
  text-align: center;
}

.info-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.avatar-large {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00b852 0%, #006b4f 100%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.info-title {
  color: #333;
  font-size: 18px;
  font-weight: 700;
}

.info-content {
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 8px;
  background: #f9f9f9;
}

.info-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
}

.info-item:last-child {
  border-bottom: none;
}

.label {
  flex: 0 0 auto;
  color: #666;
  font-size: 14px;
}

.value {
  min-width: 0;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  word-break: break-all;
}

.language-switch {
  display: flex;
  align-items: center;
}

.lang-option {
  color: #999;
  font-size: 14px;
  cursor: pointer;
}

.lang-option.active {
  color: #00b852;
  font-weight: 700;
}

.divider {
  margin: 0 8px;
  color: #eee;
}
</style>
